import dayjs, { Dayjs } from "dayjs";

import { IServiceHours } from "@/interfaces/service-hours.interface";
import { ConfigurationTabMessages } from "@/messages/customer/configuration-tab.messages";

export const WEEK_DAY_OPTIONS = (messages: ConfigurationTabMessages) => [
  { value: 1, label: messages.weekDayMonday },
  { value: 2, label: messages.weekDayTuesday },
  { value: 3, label: messages.weekDayWednesday },
  { value: 4, label: messages.weekDayThursday },
  { value: 5, label: messages.weekDayFriday },
  { value: 6, label: messages.weekDaySaturday },
  { value: 7, label: messages.weekDaySunday },
];

export const getWeekDayLabel = (weekDay: number, messages: ConfigurationTabMessages) => {
  return WEEK_DAY_OPTIONS(messages).find((option) => option.value === weekDay)?.label ?? weekDay;
};

export const formatTimeDisplay = (value: string) => dayjs(value).format("HH:mm");

export const formatDateDisplay = (value: string) => dayjs(value).format("DD/MM/YYYY");

export const formatTimeForApi = (value: Dayjs | null) => {
  if (!value) return "";
  return value.format("YYYY-MM-DDTHH:mm:ss");
};

export const formatDateForApi = (value: Dayjs | null) => {
  if (!value) return "";
  return value.startOf("day").format("YYYY-MM-DDTHH:mm:ss");
};

export const parseTimeFromApi = (value?: string) => (value ? dayjs(value) : null);

export const parseDateFromApi = (value?: string) => (value ? dayjs(value) : null);

export const getWeekDayDescription = (weekDay: number, messages: ConfigurationTabMessages) => {
  return getWeekDayLabel(weekDay, messages);
};

export const sortServiceHoursByWeekDay = (items: IServiceHours[]) =>
  [...items].sort((a, b) => {
    if (a.weekDay !== b.weekDay) return a.weekDay - b.weekDay;
    return dayjs(a.startOperationHour).valueOf() - dayjs(b.startOperationHour).valueOf();
  });

export const WEEKDAY_VALUES = [1, 2, 3, 4, 5, 6, 7] as const;

export const BUSINESS_WEEKDAY_VALUES = [1, 2, 3, 4, 5] as const;

export const isSameWeekDaySelection = (selected: number[], preset: readonly number[]) => {
  if (selected.length !== preset.length) return false;

  const sorted = [...selected].sort((a, b) => a - b);
  return preset.every((day, index) => sorted[index] === day);
};
